// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__22vDv","inputDescription":"styles_inputDescription__2YRUp"};